export default __webpack_public_path__ + "static/media/icon_event.5bc257ce.svg";